import React from "react";
import ReactCountryFlag from "react-country-flag";
import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

interface MainGuestCellProps {
  id?: string;
  bookingId?: string;
  firstName?: string;
  lastName?: string;
  nationality?: string;
  className?: string;
  flagClassName?: string;
  fullNameClassName?: string;
}

export const MainGuestCell: React.FC<MainGuestCellProps> = ({
  id,
  bookingId,
  firstName,
  lastName,
  nationality,
  className,
  flagClassName,
  fullNameClassName,
}) => {
  const fullName = [firstName, lastName].filter(Boolean).join(" ");

  if (!id) {
    return null;
  }

  const guestProfilePath = bookingId
    ? `/reservations/guests/${id}?bookingId=${encodeURIComponent(bookingId)}`
    : `/reservations/guests/${id}`;

  return (
    <div className={`flex items-center justify-center gap-2 ${className}`}>
      {nationality && (
        <ReactCountryFlag
          countryCode={nationality}
          svg
          className={cn("!h-8 !w-6", flagClassName)}
        />
      )}
      <Link
        onClick={(event) => event.stopPropagation()}
        to={guestProfilePath}
        className={cn("hover:underline", fullNameClassName)}
      >
        {fullName || "-"}
      </Link>
    </div>
  );
};
